export default "__VITE_ASSET__8735017e__"